const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  stripeKey: process.env.REACT_APP_STRIPE_KEY || '',
}

export default config
